
import { PlycaDataService } from '../../../services/plyca.service';
import {
  UserDTO,
  OrganizationalUnitDTO
} from '../../api/plyca-dtos';
import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { ServiceLocator } from './../../ServiceLocator';
import { UserService } from '../../user.service';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { finalize, switchMap } from 'rxjs/operators';

export class UserDetailDTOModal {
  public user: UserDTO;
  constructor(public userItemParameter: UserDTO) {
    this.user = userItemParameter;
  }
}

@Component({
  selector: 'userDetail',
  templateUrl: 'userDetail.template.html'
})
export class userDetailComponent extends BaseComponent
  implements OnInit, OnDestroy {

  user: UserDTO;
  organizationalUnit: OrganizationalUnitDTO;
  plycaService: PlycaDataService;
  userService: UserService;
  tagsParent: string[];
  userLetters: string;
  userColor: string;
  userFullName: string;
  windowHash: any;


  constructor(public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    public uiService: UIService,
    private elem: ElementRef
  ) {
    super();
    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.userService = ServiceLocator.injector.get(UserService);
    this.user = dialogConfig['context'].user;
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => this.tagsParent = helpTags)));
    this.getUser();
  }

  getUser() {
    this.subscribe(
      this.plycaService.getUser(this.user), (param: UserDTO) => {
        console.log('persona encontrada');
        this.user = param;
        console.log('Usuariooooooo', this.user);
        this.getOrganizationalUnit();

        this.userLetters = this.userService.getUserLettersSelectedUser(this.user);
        this.userColor = this.userService.getUserColorSelectedUser(this.user);
        this.userFullName = this.userService.getUserFullNameSelectedUser(
          this.user
        );
      });
  }


  loadActionsInit() {
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.VIEW_USER));
    this.windowHash = generateRandomIdentifier();
    this.headerActionsService.clearWindowActions(this.windowHash);

    this.subscribe(
      this.headerActionsService
        .addWindowAction(
          'General.close',
          'fas fa-times',
          'btn-secondary',
          true,
          this.windowHash

        ), success => {
          this.ref.close();
        });


  }

  getOrganizationalUnit() {
    this.subscribe(
      this.plycaService
        .getOrganizationalUnit(this.user.organizationalUnit)
      , (param: OrganizationalUnitDTO) => {
        this.organizationalUnit = param;
        console.log('organizationalUnit', this.organizationalUnit);
      });
  }

  ngOnInit(): void {
    console.log('ngOnInit');
  }


  ngOnDestroy() {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        this.headerActionsService.clearWindowActions(this.windowHash);
        super.ngOnDestroy();
      }
      )));
  }

  ngAfterContentInit(): void {
    console.log('ngAfterContentInit');
    this.loadActionsInit();
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    console.log('afterLoadComplete');
  }

  public isLoaded(): boolean {
    return true;
  }

  public close() {
    console.log('cerrar');
    this.ref.close();
  }
}
